import React, { useContext, useEffect, useState, useCallback } from "react";
import {
  APIProvider,
  Map,
  AdvancedMarker,
  Pin,
  useAdvancedMarkerRef,
  InfoWindow,
} from "@vis.gl/react-google-maps";
import { LocationContext } from "./context";

let defaultZoom = 6;
let INITIAL_CAMERA = {
  center: {
    lat: 56.193736937149936,
    lng: -4.957114531250024,
  },
  zoom: defaultZoom,
};

const ProjectMarker = ({ location, activeLocation, setActiveLocation }) => {
  const [markerRef, marker] = useAdvancedMarkerRef();
  const [openInfoWindow, setInfowindowOpen] = useState(false);

  useEffect(() => {
    if (!activeLocation) {
      setInfowindowOpen(false);
      return;
    }

    // open only if THIS marker matches the activeLocation
    if (activeLocation.slug === location.slug) {
      setInfowindowOpen(true);
    } else {
      setInfowindowOpen(false);
    }
  }, [activeLocation]);

  let pinStyle = {
    backgroundColor:
      location.tags && location.tags.includes("In Development")
        ? "#1c3f82"
        : "#27a334",
  };

  return (
    <>
      <AdvancedMarker
        ref={markerRef}
        position={{
          lat: Number(location.lat_lng.latitude),
          lng: Number(location.lat_lng.longitude),
        }}
        onClick={() => {
          setActiveLocation(location);
          setInfowindowOpen(true);
        }}
        title={location.location_name}
      >
        <Pin
          background={pinStyle.backgroundColor}
          borderColor={"#010101"}
          glyphColor={"#FFF"}
        />
      </AdvancedMarker>
      {openInfoWindow && activeLocation && (
        <InfoWindow
          anchor={marker}
          maxWidth={200}
          onCloseClick={() => {
            setActiveLocation(null);
            setInfowindowOpen(false);
          }}
        >
          <div className="info-window">
            <h5>{activeLocation.location_name}</h5>
            <a href={`/our-projects/${activeLocation.slug}`}>
              More information
            </a>
          </div>
        </InfoWindow>
      )}
    </>
  );
};

const LocationMap = () => {
  const { locations, loading, activeLocation, setActiveLocation } =
    useContext(LocationContext);
  const [cameraProps, setCameraProps] = useState(INITIAL_CAMERA);

  const handleCameraChange = useCallback((ev) => {
    setCameraProps(ev.detail);
  }, []);

  useEffect(() => {
    if (activeLocation) {
      setCameraProps({
        center: {
          lat: Number(activeLocation.lat_lng.latitude),
          lng: Number(activeLocation.lat_lng.longitude),
        },
        zoom: 15,
      });
    } else {
      setCameraProps(INITIAL_CAMERA);
    }
  }, [activeLocation]);

  if (loading || !locations) {
    return <div className="gp-location-map-loading">Loading map...</div>;
  }

  return (
    <div className="gp-location-map">
      <APIProvider apiKey={`AIzaSyAc6ch-OSLhuC9v8RVfLfBPgAyyz8dHDdc`}>
        <Map
          {...cameraProps}
          mapId="DEMO_MAP_ID"
          gestureHandling="cooperative"
          onCameraChanged={handleCameraChange}
        >
          {locations.map((location, index) => {
            return (
              <ProjectMarker
                key={index}
                location={location}
                activeLocation={activeLocation}
                setActiveLocation={setActiveLocation}
              />
            );
          })}
        </Map>
      </APIProvider>
    </div>
  );
};

export default LocationMap;
